import { useCallback, useState } from "react";

export const useSessionDismissFlag = (key: string) => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(key) === "1";
    } catch {
      return false;
    }
  });

  const dismiss = useCallback(() => {
    try {
      sessionStorage.setItem(key, "1");
    } catch {
      // Ignore write failures and still hide locally for this render lifecycle.
    }
    setDismissed(true);
  }, [key]);

  return [dismissed, dismiss] as const;
};
